// extracted by mini-css-extract-plugin
export default {"intro":"ModalClonarTarifa_intro__3jHV3","form":"ModalClonarTarifa_form__7tI5a","input":"ModalClonarTarifa_input__xUZXp"};